import _each from 'lodash/each';
import _noop from 'lodash/noop';
import _isFunction from 'lodash/isFunction';
import _isObject from 'lodash/isObject';
var devConsole = console;

if (process.env === 'production' || process.env === 'staging') {
  devConsole = Object.assign({}, console); // TODO: Log errors to server?

  _each(devConsole, function (methodOrVariable, key) {
    if (_isFunction(methodOrVariable)) {
      devConsole[key] = _noop;
      return;
    }

    if (_isObject(methodOrVariable)) {
      devConsole[key] = {};
      return;
    }

    devConsole[key] = undefined;
  });
}

export default devConsole;